import { SmsAction } from "../actions/sms.action";
import { SmsActionType } from "../action-types/sms.action.types";

interface SmsRepoState {
  newUserSms: string[];
}
const initialState: SmsRepoState = {
  newUserSms: [],
};

const smsReducer = (
  state: SmsRepoState = initialState,
  action: SmsAction
): SmsRepoState => {
  switch (action.type) {
    case SmsActionType.SET_UPDATE_NEWSMS_LIST:
      return {
        ...state,

        newUserSms: [...state.newUserSms, action.payload.trim().toLowerCase()],
      };
    case SmsActionType.SET_REDUCE_NEWSMS_DATA:
      console.log("action?.payload", action?.payload);
      return {
        ...state,
        newUserSms: state?.newUserSms?.filter(
          (node: string) =>
            !action.payload
              .toLowerCase()
              .trim()
              .includes(node?.toLowerCase().trim())
        ),
      };
    default:
      return state;
  }
};

export default smsReducer;
